/**
 * ProtectedAdminRoutes
 *
 * Guards routes that belong to the admin panel (/admin, /clients, /cases, etc.).
 * - Unauthenticated users → redirect to /login.
 * - Authenticated users without permission for the current path → redirect to
 *   /admin (their default landing page) rather than /login so they stay logged in.
 * - Authorised users → render the outlet normally.
 *
 * Route-access rules are defined centrally in src/permissions/index.ts.
 */
import { Suspense } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useUserStore from "../../store/user";
import { PresenceTracker } from "../presence-tracker";
import { AlertaDeRecusadas } from "../alerta-recusadas";
import { LoadingContainer } from "./styles";
import { hasRouteAccess, isAdminRole } from "../../permissions";

export const ProtectedAdminRoutes = () => {
  const { user } = useUserStore();
  const location = useLocation();

  const LoadingComp = () => (
    <LoadingContainer>
      <div className="loading">
        <h1 className="lbl">Carregando...</h1>
      </div>
    </LoadingContainer>
  );

  if (!user) {
    return <Navigate to="/login" />;
  }

  // CUSTOMER users have no admin-panel access at all.
  if (!isAdminRole(user.userType)) {
    return <Navigate to="/home" />;
  }

  // Check granular route permissions for admin-type roles.
  if (!hasRouteAccess(user.userType, location.pathname)) {
    // Redirect to the admin dashboard — the user stays authenticated.
    return <Navigate to="/admin" />;
  }

  return (
    <Suspense fallback={<LoadingComp />}>
      <PresenceTracker />
      <AlertaDeRecusadas />
      <Outlet />
    </Suspense>
  );
};
